// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon from '@bubble-ui/temp-icon-base';
// @ts-expect-error
import withDeprecationWarning from '@bubble-ui/hoc-with-deprecation-warning';
var IconSpendingCategoriesPath = 'M18.5,16.3 C18.5,17.5 17.5,18.5 16.3,18.5 L3.8,18.5 C2.5,18.5 1.5,17.5 1.5,16.3 L1.5,3.8 C1.5,2.5 2.5,1.5 3.8,1.5 L6.8,1.5 L6.8,10 C6.8,10.3 6.9,10.6 7.2,10.7 C7.5,10.8 7.9,10.7 8.1,10.5 L10,8.2 L11.9,10.5 C12.1,10.7 12.3,10.8 12.5,10.8 C12.6,10.8 12.7,10.7 12.8,10.7 C13.1,10.6 13.3,10.3 13.3,10 L13.3,1.5 L16.3,1.5 C17.5,1.5 18.5,2.5 18.5,3.8 L18.5,16.3 Z M8.3,1.5 L11.8,1.5 L11.8,7.9 L10.6,6.5 C10.3,6.2 9.7,6.2 9.4,6.5 L8.3,7.9 L8.3,1.5 Z M16.3,0 L3.8,0 C1.7,0 0,1.7 0,3.8 L0,16.3 C0,18.3 1.7,20 3.8,20 L16.3,20 C18.3,20 20,18.3 20,16.3 L20,3.8 C20,1.7 18.3,0 16.3,0 Z M10.5,14.8 L4.5,14.8 C4.1,14.8 3.8,15.1 3.8,15.5 C3.8,15.9 4.1,16.3 4.5,16.3 L10.5,16.3 C10.9,16.3 11.3,15.9 11.3,15.5 C11.3,15.1 10.9,14.8 10.5,14.8';
var IconSpendingCategories = withDeprecationWarning({
  name: 'IconSpendingCategories',
  removalDate: 'v6.0.0',
  useInstead: 'IconOrder'
})(baseIcon('IconSpendingCategories', {
  getPath: () => IconSpendingCategoriesPath
}));
IconSpendingCategories.displayName = 'IconSpendingCategories';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0. Use IconOrder instead.
 */
export default IconSpendingCategories;
//# sourceMappingURL=index.js.map